import { useCallback } from 'react';
import arrowDown from '~/assets/icons/arrow_down.svg';
import helpFaq from '~/assets/icons/help_faq.svg';
import { playSound, Sound } from '~/assets/sounds';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import {
	setFaqIndex,
	setFaqSectionIndex,
	setReportVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { faqContent } from '../FAQ';
import { getHeight } from './FAQSidebar.model';
import {
	StyledArrowContainer,
	StyledContainer,
	StyledMenuHeading,
	StyledMenuHeadingTop,
	StyledMenuItem,
	StyledMenuItemsContainer,
	StyledSection,
	StyledShadowBottom,
	StyledShadowTop,
	StyledSupportButtonContainer,
	StyledSupportButtonContent,
} from './FAQSidebar.styled';

const FAQSidebar = () => {
	const dispatch = useLayoutDispatch();
	const faqSectionIndex = useLayoutSelector(
		(state) => state.mainMenu.faqSectionIndex,
	);
	const faqIndex = useLayoutSelector((state) => state.mainMenu.faqIndex);

	const handleOpenSection = useCallback(
		(index: number) => {
			if (faqSectionIndex === index) {
				dispatch(setFaqIndex(-1));
				dispatch(setFaqSectionIndex(-1));
				return;
			}
			dispatch(setFaqIndex(0));
			dispatch(setFaqSectionIndex(index));
		},
		[faqSectionIndex],
	);

	return (
		<StyledContainer>
			<StyledShadowTop />
			<StyledShadowBottom />
			{faqContent.map((item, index) => (
				<StyledSection key={index}>
					<StyledMenuHeading
						$active={faqSectionIndex === index}
						onClick={() => {
							handleOpenSection(index);
							playSound(Sound.ClickButton);
						}}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
					>
						<StyledMenuHeadingTop>
							<Text>{item.title}</Text>
							<StyledArrowContainer>
								<img src={arrowDown} />
							</StyledArrowContainer>
						</StyledMenuHeadingTop>
					</StyledMenuHeading>
					<Divider
						$direction="H"
						style={{ opacity: faqSectionIndex === index ? 0.1 : 0 }}
						$transition
					/>
					<StyledMenuItemsContainer
						$isOpen={faqSectionIndex === index}
						$height={getHeight(item?.items?.length)}
					>
						<div>
							{item.items.map((text, i) => (
								<StyledMenuItem
									key={i}
									$active={faqIndex === i}
									onClick={() => {
										dispatch(setFaqIndex(i));
										playSound(Sound.ClickButton);
									}}
									onMouseEnter={() => playSound(Sound.LinkCursor)}
								>
									<Text>{text.title}</Text>
								</StyledMenuItem>
							))}
						</div>
					</StyledMenuItemsContainer>
				</StyledSection>
			))}
			<StyledSupportButtonContainer>
				<Button
					color={ButtonColors.Help}
					height={ButtonHeight.Height60}
					borderRadius={ButtonBorderRadius.Radius5}
					onClick={() => {
						dispatch(setReportVisible(true));
						playSound(Sound.ClickButton);
					}}
				>
					<StyledSupportButtonContent>
						<img src={helpFaq} />
						<Text>Создать новое обращение</Text>
					</StyledSupportButtonContent>
				</Button>
			</StyledSupportButtonContainer>
		</StyledContainer>
	);
};

export { FAQSidebar };
